import { cn } from "../../lib/utils";
import { SelectClear } from "./SelectClear";
import { SelectTriggerButton, type SelectTriggerButtonProps } from "./SelectTriggerButton";

/** The trigger with its clear button beside it, for a `clearable` Select; `className` sizes the pair. */
export const SelectTriggerClearableRow = ({ className, ...props }: Omit<SelectTriggerButtonProps, "asChild">) => (
  <div data-slot="select-trigger-row" className={cn("flex min-w-0 items-center gap-1", className)}>
    <SelectTriggerButton className="min-w-0 flex-1" {...props} />
    <SelectClear />
  </div>
);
